module.exports = __webpack_public_path__ + "img/favicon-50x50-01.237b6530.svg";